export default __webpack_public_path__ + "static/media/logo-powered-by-autopass.4dc116d4.svg";